import React from 'react';
import {useSelector} from 'react-redux';

import {getPercent} from '@ey/utils';
import Utility from '../../../../../../util/utilityfunctions';

import {IconoirWarningCircle} from '@ey-xd/motif-icon';

import Icon from '@ey/canvascoreservices/Icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import Tooltip from '../../../../../CoreWrappers/Tooltip';

const NumberPercentColumnComponent = ({item, getPartial, getTotal, prop}) => {
	const numberFormat = useSelector(({userPreferences}) => userPreferences.numberFormat);
	const isCalculable = getPartial !== null && getTotal !== null;
	const showPercent = item[prop] > 0 && isCalculable;

	const formatNumber = (number) => `${Utility.getFormattedNumber(numberFormat, number)}`;

	const renderPercent = () => {
		const percentage = getPercent(getPartial(item), getTotal(item));

		return ` (${isNaN(percentage) ? 0 : formatNumber(percentage)}%)`;
	};

	return `${formatNumber(item[prop])}${showPercent ? renderPercent() : ''}`;
};

export const config = ({
	id,
	fullId = null,
	label,
	prop,
	getPartial = null, // function that takes item as parameter
	getTotal = null, // function that takes item as parameter
	width = 'minmax(var(--px-160), 1fr)',
	customHeaderTooltip = null
}) => {
	const configObj = {
		id: fullId ? fullId : `${id}NumberPercentColumn`,
		label,
		propName: prop,
		sortBy: prop,
		width,
		align: 'right',
		headerAlign: 'right',
		customCell: (item) => (
			<NumberPercentColumnComponent item={item} getPartial={getPartial} getTotal={getTotal} prop={prop} />
		)
	};

	if (customHeaderTooltip)
		configObj.customHeaderCell = (item) => {
			const renderTrigger = () => <Icon src={IconoirWarningCircle} />;

			const props = {
				trigger: renderTrigger(),
				tooltipText: customHeaderTooltip,
				placement: 'top'
			};

			return (
				<>
					<OutputText body2 title={label} ellipsis>
						{label}
					</OutputText>
					<Tooltip {...props} />
				</>
			);
		};

	return configObj;
};
